import { render, staticRenderFns } from "./BoardHead.vue?vue&type=template&id=152691d4&"
import script from "./BoardHead.vue?vue&type=script&lang=js&"
export * from "./BoardHead.vue?vue&type=script&lang=js&"
import style0 from "./BoardHead.vue?vue&type=style&index=0&id=152691d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports